import {
	FlexButton,
	MimaButton,
	MimaDropdown,
	MimaInput,
	MimaText,
	Modal,
	ReceiptCheckBox as RCB,
} from '../../components';
import styles from '../../assets/styles/Employees/Employees.module.scss';
import { employeeStore, payrollStore } from '../../stores';
import SuccessImg from '../../assets/img/success.png';
import { MdOutlineInfo } from 'react-icons/md';
import { Formik } from 'formik';
import { toJS } from 'mobx';
import React from 'react';

const ManagePayroll = ({
	closeModal,
	configureSuccess,
	showConfigureSuccess,
	loading,
	onSubmit,
	validationSchema,
	newConfig,
	showNewConfig,
	showOldConfig,
	editConfig,
	showEditConfig,
	onUpdateSubmit,
	goBack,
}) => {
	const configs = payrollStore.payrollConfigurations;
	const {
		dayOfMonth,
		dayOfWeek,
		paymentCycle,
		payOnlyOnWorkDays,
		biWeekDayOneOfMonth,
		biWeekDayTwoOfMonth,
		employeeGroup,
		reviewerLevels,
	} = payrollStore?.selectedConfiguredPayroll;

	return (
		<Modal closeModal={closeModal} goBack={goBack}>
			<>
				<MimaText variant="subtitle" align="center" mb={4}>
					Configure Payroll
				</MimaText>
				<div className={styles.beneficiary}>
					<div
						className={`${
							!newConfig
								? styles.beneficiary__saved
								: styles.beneficiary__saved_b
						}`}
						onClick={showOldConfig}>
						Previous Configs
					</div>
					<div
						className={`${
							!newConfig ? styles.beneficiary__new : styles.beneficiary__new_b
						}`}
						onClick={showNewConfig}>
						Create New Config
					</div>
				</div>

				{newConfig && !editConfig && !configureSuccess && (
					<>
						<MimaText variant="bodyBold" align="center" mb={1}>
							Create a new Configuration
						</MimaText>
						<Formik
							initialValues={{
								dayOfMonth: 0,
								dayOfWeek: '',
								biWeekDayOneOfMonth: "",
								biWeekDayTwoOfMonth: "",
								paymentCycle: 'MONTHLY',
								payOnlyOnWorkDays: false,
								employeeGroup: '',
								reviewerLevels: "",
							}}
							validationSchema={validationSchema}
							onSubmit={onSubmit}>
							{({
								handleChange,
								handleBlur,
								handleSubmit,
								setFieldValue,
								values,
								errors,
								touched,
							}) => (
								<div>
									<MimaText 
										mb={2}
										variant="small"
										color="var(--color-primary)"
										width={38}
										style={{display: "flex", alignItems: "center"}}
									>
										
										<MdOutlineInfo style={{fontSize: "2.5rem", marginRight: "1rem"}}/> Payment Cycle
									</MimaText>
									<div className={styles.checks}>
										<RCB
											title="Weekly"
											id="WEEKLY"
											name="paymentCycle"
											onChange={() => {
												setFieldValue('paymentCycle', 'WEEKLY');
											}}
											checked={values.paymentCycle === 'WEEKLY'}
											value="WEEKLY"
										/>
										<RCB
											title="BI-WEEKLY"
											id="BI-WEEKLY"
											name="paymentCycle"
											onChange={() => {
												setFieldValue('paymentCycle', 'BI-WEEKLY');
											}}
											checked={values.paymentCycle === 'BI-WEEKLY'}
											value="BI-WEEKLY"
										/>
										<RCB
											title="Monthly"
											id="MONTHLY"
											name="paymentCycle"
											onChange={() => {
												setFieldValue('paymentCycle', 'MONTHLY');
											}}
											checked={values.paymentCycle === 'MONTHLY'}
											value="MONTHLY"
										/>
									</div>
									{/* <MimaDropdown
										labelTitle="Group(optional)"
										placeholder="Select"
										name="employeeGroup"
										currentValue={values.employeeGroup}
										value={values.employeeGroup}
										id="employeeGroup"
										onChange={data => {
											setFieldValue('employeeGroup', data.key);
										}}
										data={employeeStore.mapGroups}
										touched={touched.employeeGroup}
									/> */}
									{values.paymentCycle === 'MONTHLY' && (
										<MimaInput
											type="number"
											min={1}
											max={31}
											labelTitle="What day in the month would you like to pay?"
											placeholder="Between 1 and 30"
											name="dayOfMonth"
											id="dayOfMonth"
											error={errors.dayOfMonth}
											touched={touched.dayOfMonth}
											value={values.dayOfMonth}
											onChange={handleChange}
											onBlur={handleBlur}
										/>
									)}
									{values.paymentCycle === 'BI-WEEKLY' && (
										<>
										<MimaInput
											type="number"
											min={1}
											max={14}
											labelTitle="What day in the first 2weeks would you like to pay?"
											placeholder="Between 1 and 14"
											name="biWeekDayOneOfMonth"
											id="biWeekDayOneOfMonth"
											error={errors.biWeekDayOneOfMonth}
											touched={touched.biWeekDayOneOfMonth}
											value={values.biWeekDayOneOfMonth}
											onChange={handleChange}
											onBlur={handleBlur}
										/>
										<MimaInput
											type="number"
											min={15}
											max={28}
											labelTitle="What day in the second 2weeks would you like to pay?"
											placeholder="Between 15 and 28"
											name="biWeekDayTwoOfMonth"
											id="biWeekDayTwoOfMonth"
											error={errors.biWeekDayTwoOfMonth}
											touched={touched.biWeekDayTwoOfMonth}
											value={values.biWeekDayTwoOfMonth}
											onChange={handleChange}
											onBlur={handleBlur}
										/>
										</>
									)}
									{values.paymentCycle === 'WEEKLY' && (
										<MimaDropdown
											labelTitle="What day in the week would you like to pay?"
											placeholder="Select"
											name="dayOfWeek"
											value={values.dayOfWeek}
											id="dayOfWeek"
											onChange={data => {
												setFieldValue('dayOfWeek', data.key);
											}}
											data={[
												'Sunday',
												'Monday',
												'Tuesday',
												'Wednesday',
												'Thursday',
												'Friday',
												'Saturday',
											].map(day => {
												return {
													key: day,
													value: day,
												};
											})}
											touched={touched.dayOfWeek}
										/>
									)}

									<MimaInput
										type="number"
										min={0}
										max={10}
										labelTitle="How many Reviewer Levels do you want"
										placeholder="Between 0 and 2"
										name="reviewerLevels"
										id="reviewerLevels"
										error={errors.reviewerLevels}
										touched={touched.reviewerLevels}
										value={values.reviewerLevels}
										onChange={handleChange}
										onBlur={handleBlur}
									/>
									{values.paymentCycle === 'MONTHLY' && (
										<>
											{' '}
											<MimaText
												mb={2}
												variant="small"
												color="var(--color-error)"
												width={38}>
												{' '}
												<MdOutlineInfo /> If the payment date falls on a
												weekend, payment should be made the Friday before the
												date
											</MimaText>
											<div className={styles.checks}>
												<RCB
													title="Yes"
													id={true}
													name="payOnlyOnWorkDays"
													onChange={() => {
														setFieldValue('payOnlyOnWorkDays', true);
													}}
													checked={values.payOnlyOnWorkDays === true}
													value={true}
												/>
												<RCB
													title="No"
													id={false}
													name="payOnlyOnWorkDays"
													onChange={() => {
														setFieldValue('payOnlyOnWorkDays', false);
													}}
													checked={values.payOnlyOnWorkDays === false}
													value={false}
												/>
											</div>
										</>
									)}
									<MimaButton
										title="Submit"
										loading={loading}
										type="submit"
										onClick={handleSubmit}
										mt={2}
									/>
								</div>
							)}
						</Formik>
					</>
				)}

				{!newConfig && !editConfig && !configureSuccess && (
					<>
						<MimaText variant="smallBold" align="center" mb={1}>
							Configured Payrolls
						</MimaText>

						{configs.length > 0 ? (
							<>
								<table className={styles.cpt}>
									<thead>
										<tr>
											<th>Group</th>
											<th>Pay Day</th>
											<th>Pay on work days</th>
											<th>No. of Reviewers</th>
											<th>No. of Approvers</th>
											<th>Action</th>
										</tr>
									</thead>

									<tbody>
										{configs.map(config => (
											<tr>
												<td>
													{config.employeeGroup?.name || 'No group selected'}
												</td>
												<td>
													{config.dayOfMonth > 0
														? config.dayOfMonth
														: config.dayOfWeek}
												</td>
												<td>{config.payOnlyOnWorkDays === 1 ? 'Yes' : 'No'}</td>
												<td>{config.reviewerLevels}</td>
												<td>{config.approverLevels}</td>
												<td
													className={styles.cpt_action}
													onClick={() => {
														payrollStore.setSelectedConfiguredPayroll(config);
														showEditConfig();
													}}>
													Edit
												</td>
											</tr>
										))}
									</tbody>
								</table>
								<MimaButton
									title="Add More configurations"
									onClick={showNewConfig}
									mt={3}
								/>
							</>
						) : (
							<>
								<MimaText align="center">
									No Previous Payroll Configurations
								</MimaText>
								<MimaButton
									title="Set a configuration"
									onClick={showNewConfig}
								/>
							</>
						)}
					</>
				)}

				{editConfig && (
					<>
						<MimaText variant="smallBold" align="center" mb={1}>
							Edit Configuration
						</MimaText>

						<Formik
							initialValues={{
								dayOfMonth,
								payOnlyOnWorkDays,
								dayOfWeek,
								biWeekDayOneOfMonth,
								biWeekDayTwoOfMonth,
								paymentCycle,
								employeeGroup: employeeGroup ? employeeGroup?._id : '',
								reviewerLevels,
							}}
							validationSchema={validationSchema}
							onSubmit={onUpdateSubmit}>
							{({
								handleChange,
								handleBlur,
								handleSubmit,
								setFieldValue,
								values,
								errors,
								touched,
							}) => (
								<div>
									<MimaText
										mb={2}
										variant="small"
										color="var(--color-error)"
										width={38}>
										{' '}
										<MdOutlineInfo /> Payment Cycle
									</MimaText>
									<div className={styles.checks}>
										<RCB
											title="Weekly"
											id="WEEKLY"
											name="paymentCycle"
											onChange={() => {
												setFieldValue('paymentCycle', 'WEEKLY');
											}}
											checked={values.paymentCycle === 'WEEKLY'}
											value="WEEKLY"
										/>
										<RCB
											title="Bi-Weekly"
											id="BI-WEEKLY"
											name="paymentCycle"
											onChange={() => {
												setFieldValue('paymentCycle', 'BI-WEEKLY');
											}}
											checked={values.paymentCycle === 'BI-WEEKLY'}
											value="BI-WEEKLY"
										/>
										<RCB
											title="Monthly"
											id="MONTHLY"
											name="paymentCycle"
											onChange={() => {
												setFieldValue('paymentCycle', 'MONTHLY');
											}}
											checked={values.paymentCycle === 'MONTHLY'}
											value="MONTHLY"
										/>
									</div>
									<MimaDropdown
										labelTitle="Group(optional)"
										placeholder={employeeGroup ? employeeGroup.name : ''}
										name="employeeGroup"
										currentValue={values.employeeGroup}
										value={values.employeeGroup}
										id="employeeGroup"
										onChange={data => {
											setFieldValue('employeeGroup', data.key);
										}}
										data={employeeStore.mapGroups}
										touched={touched.employeeGroup}
									/>
									{values.paymentCycle === 'MONTHLY' && (
										<MimaInput
											type="number"
											min={1}
											max={31}
											labelTitle="What day in the month would you like to pay?"
											placeholder="Between 1 and 30"
											name="dayOfMonth"
											id="dayOfMonth"
											error={errors.dayOfMonth}
											touched={touched.dayOfMonth}
											value={values.dayOfMonth}
											onChange={handleChange}
											onBlur={handleBlur}
										/>
									)}
									{values.paymentCycle === 'WEEKLY' && (
										<MimaDropdown
											labelTitle="What day in the week would you like to pay?"
											placeholder={values.dayOfWeek}
											name="dayOfWeek"
											value={values.dayOfWeek}
											id="dayOfWeek"
											currentValue={values.dayOfWeek}
											onChange={data => {
												setFieldValue('dayOfWeek', data.key);
											}}
											data={[
												'Sunday',
												'Monday',
												'Tuesday',
												'Wednesday',
												'Thursday',
												'Friday',
												'Saturday',
											].map(day => {
												return {
													key: day,
													value: day,
												};
											})}
											touched={touched.dayOfWeek}
										/>
									)}
										{values.paymentCycle === 'BI-WEEKLY' && (
										<>
										<MimaInput
											type="number"
											min={1}
											max={13}
											labelTitle="What day in the first week would you like to pay?"
											placeholder="Between 1 and 13"
											name="biWeekDayOneOfMonth"
											id="biWeekDayOneOfMonth"
											error={errors.biWeekDayOneOfMonth}
											touched={touched.biWeekDayOneOfMonth}
											value={values.biWeekDayOneOfMonth}
											onChange={handleChange}
											onBlur={handleBlur}
										/>
										<MimaInput
											type="number"
											min={14}
											max={30}
											labelTitle="What day in the second week would you like to pay?"
											placeholder="Between 14 and 30"
											name="biWeekDayTwoOfMonth"
											id="biWeekDayTwoOfMonth"
											error={errors.biWeekDayTwoOfMonth}
											touched={touched.biWeekDayTwoOfMonth}
											value={values.biWeekDayTwoOfMonth}
											onChange={handleChange}
											onBlur={handleBlur}
										/>
										</>
									)}
									<MimaInput
										type="number"
										min={0}
										max={10}
										labelTitle="How many people should review?"
										placeholder="Between 0 and 10"
										name="reviewerLevels"
										id="reviewerLevels"
										error={errors.reviewerLevels}
										touched={touched.reviewerLevels}
										value={values.reviewerLevels}
										onChange={handleChange}
										onBlur={handleBlur}
									/>
									{values.paymentCycle === 'MONTHLY' && (
										<>
											<MimaText
												mb={2}
												variant="small"
												color="var(--color-error)"
												width={38}>
												{' '}
												<MdOutlineInfo /> If the payment date falls on a
												weekend, payment should be made the Friday before the
												date
											</MimaText>
											<div className={styles.checks}>
												<RCB
													title="True"
													id={true}
													name="payOnlyOnWorkDays"
													onChange={() => {
														setFieldValue('payOnlyOnWorkDays', true);
													}}
													checked={values.payOnlyOnWorkDays === true}
													value={true}
												/>
												<RCB
													title="False"
													id={false}
													name="payOnlyOnWorkDays"
													onChange={() => {
														setFieldValue('payOnlyOnWorkDays', false);
													}}
													checked={values.payOnlyOnWorkDays === false}
													value={false}
												/>
											</div>
										</>
									)}
									<MimaButton
										title="Submit"
										loading={loading}
										type="submit"
										onClick={handleSubmit}
										mt={2}
									/>
								</div>
							)}
						</Formik>
					</>
				)}
			</>
		</Modal>
	);
};

export default ManagePayroll;
